<!--
  @Description 天数选择弹窗
  @Date 2021-12-31
  @Author liushuo
-->
<template>
  <vxe-modal
    ref="modal"
    size="mini"
    v-model="formVisible"
    title="天数"
    width="300px"
  >
    <el-input-number
      v-model="num"
      :min="0"
      :step="1"
      step-strictly
    ></el-input-number>
    <el-button
      @click="handleCommit"
      style="float: right; margin-top: 10px"
      size="mini"
      type="primary"
      >确认</el-button
    >
  </vxe-modal>
</template>
<script>
export default {
  name: 'daySelect',
  data () {
    return {
      formVisible: false,
      num: 1,
      // 当前选中行的id
      rowID: -1,
      // 当前选中行的类型 [技术测试、业务测试、提出人]
      type: '',
    }
  },
  methods: {
    // 提交
    async handleCommit () {
      this.$emit('sureBackDay', this.num)
      this.$nextTick(() => {
        this.formVisible = false
      })
    },
  },
}
</script>
<style lang='less' scoped>
// vxemodal部分，美化标题太大的问题
/deep/ .vxe-modal--header {
  // font-size: 12px !important;
  height: 26px !important;
  padding: 2px 10px 0 10px !important;
}

// vxemodal关闭按钮
/deep/ .vxe-modal--close-btn {
  position: absolute !important;
  right: 8px !important;
  top: 6px !important;
  z-index: 1 !important;
  cursor: pointer !important;
}

// vxemodal标题
/deep/ .vxe-modal--title {
  font-size: 12px !important;
}
</style>